/**
 * @module LocalizationServiceProxy
 * @param  {object} root    Window/Node
 * @param  {function} factory  LocalizationServiceProxy factory
 * @return {LocalizationServiceProxy}  LocalizationServiceProxy
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define('localizationServiceProxy', ['repositoryService', 'localizerConfig'],
      function(repositoryService, localizerConfig) {
        return factory(root, repositoryService, localizerConfig);
      });
  } else {
      root.LocalizationServiceProxy = factory(root, repositoryService, localizerConfig);
  }
})(this, function(root, repositoryService, localizerConfig) {


  /**
   * Proxies localization-service
   * @type {LocalizationServiceProxy}
   */
  var localizationServiceProxy = {
    config: localizerConfig.getConfig(),
    
    /**
     * @function GetStore
     * @description Call localization-service and get local store requested.
     * @readOnly
     * @param  {string} storeId Store to be retrieved.
     * @return {Promise<LocalizationResponse>} promise - Promise to resolve/reject Localization Response
     */
    getStore: function(storeId) {
      var localizationServiceUrl = this.config.localizationApiHost + this.config.service + '/' + storeId + '.jsonp' + '?show=metadata, localstore';
      return repositoryService.get(localizationServiceUrl);
    },
    
    /**
     * @function GetStoreHours
     * @description Call Store Search Service and get store hours requested.
     * @readOnly
     * @param  {string} storeId Store to be retrieved.
     * @return {Promise<LocalizationResponse>} promise - Promise to resolve/reject Localization Response
     */
    getStoreFromSSS: function(storeId) {
      var storeSearchServiceUrl = this.config.host + this.config.storeSearchService + '?' + 'type=json' + '&storeid='+ storeId ;
      return repositoryService.get(storeSearchServiceUrl);
    },
    /**
     * @function GetLocalStore
     * @readOnly
     * @description Call localization-service to get the local store closest to the user. <br>
     * Localization-service uses different mechanisms to localize the user and responds with local store and workflow.
     * 
     * @param  {Position} position - Position, an optional, holds user consent lat, long, accuracy.
     * @return {Promise<LocalizationResponse>} promise - Promise to resolve/reject Localization Response
     */
    getLocalStore: function(coordinates) {
      var localizationServiceUrl = this.config.localizationApiHost + this.config.service + '.jsonp?' + (coordinates ? 'latitude=' + coordinates.latitude + '&longitude=' + coordinates.longitude + '&accuracy=' + coordinates.accuracy + '&' : '') + 'show=metadata, localstore';
      return repositoryService.get(localizationServiceUrl);
    },

    /**
     * @function GetMetadata
     * @readOnly
     * @description Call localization-service to get the metadata, Metadata helps to determine if user is internal/external.
     * 
     * @return {Promise<LocalizationResponse>} promise - Promise to resolve/reject localization Response
     */
    getMetadata: function() {
      var localizationServiceUrl = this.config.localizationApiHost + this.config.service + '.jsonp?' + 'show=metadata';
      return repositoryService.get(localizationServiceUrl);
    },

    /**
     * @function GetNearestStoreByRadius
     * @readOnly
     * @description Call Store Search Service to get GetNearestStoreByRadius
     * 
     * @return {Promise<LocalizationResponse>} promise - Promise to resolve/reject localization Response
     */
    getNearestStoreByRadius: function(radius, latitude, longitude) {
      var localizationServiceUrl = this.config.host + "/StoreSearchServices/v2/storesearch?radius=" + radius + "&latitude=" + latitude +"&longitude=" + longitude + "&type=json&pagesize=20";
      return repositoryService.get(localizationServiceUrl);
    }
  };

  return localizationServiceProxy;

});


//////////////////
// WEBPACK FOOTER
// ./src/localizationServiceProxy.js
// module id = 6
// module chunks = 0